/**
 * Keep instant PLP wishlist placeholders in sync when color swatches change variant.
 * Visual toggle on click is handled inside Swish Headless Wishlist Button (not here).
 */
document.addEventListener(
  'change',
  (event) => {
    const input = event.target.closest('.product-card__swatch-list [type="radio"]');
    if (!input) {
      return;
    }

    const card = input.closest('product-card');
    if (!card) {
      return;
    }

    const button = card.querySelector('.wishlist-collection-button .wkh-button[data-variant-id]');
    if (!button) {
      return;
    }

    const variantId = input.dataset.variantId;
    if (!variantId || button.dataset.variantId === variantId) {
      return;
    }

    button.dataset.variantId = variantId;
  },
  true
);
